<div class="overlay-container">
	<div class="main-content">
		<div class="content-area">
			<ng-content select=".main-panel"></ng-content>
		</div>
	</div>

	@if (isSupportOpen()) {
		<div class="support-content">
			<div class="content-area">
				<ng-content select=".support-panel"></ng-content>
			</div>
		</div>
	}
</div>
